import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_limit_use_fixed_term_contracts'

export const dataPointDefinition = {
  retracedId: 'does_facility_limit_use_fixed_term_contracts',
  name: 'Does the facility limit the use of fixed-term contracts?',
  description:
    'The intent of this question is to understand if the facility places limits on the use of fixed-term contracts. ',
  meta: {
    slcpMeta: {
      key: 'ep-3--8',
      number: 'RH-EMP-17',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ep-3--8', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26980,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
